import React, { SVGProps } from 'react';

export const ParagraphLong = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.9585 16.0419L16.042 16.0419" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <rect x="3.9585" y="3.95837" width="12.0835" height="9.15076" rx="1" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
